import React, { JSX } from "react";
import { BtnState } from "../interfaces/App";
import Icon, { IconType } from "./Icon";

interface IProps {
    id?: string;
    label?: string|JSX.Element;
    icon?: IconType;
    onClick: () => void;
    className?: string;
    disabled?: boolean;
    title?: string
}
function Button(props: IProps) {
    return (
        <button
            onClick={(ev) => {ev.stopPropagation(); props.onClick()}}
            className={props.className ? props.className : props.disabled ? " button_inactive" : " button"}
            disabled={props.disabled}
            title={props.title}
        >
            {props.icon ? <Icon icon={props.icon} state={BtnState.active}/> : props.label}
        </button>
    );
}
export default (Button);
